// extracted by mini-css-extract-plugin
export default {"thirdProduct":"ThirdProduct_thirdProduct__EfWpm","description":"ThirdProduct_description__3YqKW"};